import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import React, { FC, useEffect, useState } from "react";
import { css } from "styled-components";
import { connect } from "react-redux";
import Select, { SelectPresentationProps } from "@insite/mobius/Select";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { AccountPreferenceService as ap } from "@MasterBluePrint/Services/AccountPreferenceService";
import { AccountPreferenceApiParameter } from "@MasterBluePrint/Services/AccountPreferenceService";
import { newGuid } from "@insite/client-framework/Common/StringHelpers";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { HasToasterContext, withToaster } from "@insite/mobius/Toast/ToasterContext";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import useLaunchDarklyFlags from "@MasterBluePrint/Common/Hooks/useLaunchDarklyFlags";

interface OwnProps extends WidgetProps {

}

const mapStateToProps = (state: ApplicationState) => ({
    apState: state,
});

type Props = OwnProps & WidgetProps & HasProduct & HasToasterContext & ReturnType<typeof mapStateToProps>;

export interface DefaultCarrierAndServiceStyles {
    carrierSelect?: SelectPresentationProps;
    serviceSelect?: SelectPresentationProps;
    serviceGridItem?: GridItemProps;
    carrierGridItem?: GridItemProps;
    defaultPreferencesTitle?: TypographyProps;
    saveButton?: ButtonPresentationProps;
    buttonGridItem?: GridItemProps;
    cancelButton?:ButtonPresentationProps;
}

const defaultCarrierAndServiceStyles: DefaultCarrierAndServiceStyles = {
    serviceGridItem: {
        width: [12, 12, 12, 9, 9],
        css: css`
            padding-left: 0.9375rem;
            padding-top: 10px;
            width:  20rem;

            @media (max-width: 767px) {
                padding-left: 0;
            }
            @media (min-width: 768px) {
                padding-left: 1.25rem;
            }
        `,
    },
    carrierGridItem: {
        width: [12, 12, 12, 9, 9],
        css: css`
                padding-left: 0.9375rem;
                padding-top: 10px;
                padding-top: 0;
                width:  20rem;
    
                @media (max-width: 767px) {
                    padding-left: 0;
                }
                @media (min-width: 768px) {
                    padding-left: 1.25rem;
                }
            `,
    },
    defaultPreferencesTitle: {
        variant: "h3",
        as: "h3",
        css: css`
            padding-top: 1.5rem;
        `,
    },
    saveButton: {
        css: css`
            margin-left: 10px;
        `,
    },
    buttonGridItem: {
        width: [12, 12, 12, 9, 9],
        css: css`
            padding-left: 0.9375rem;
            padding-top: 10px;
            width: 20rem;
            display: flex;
            justify-content: flex-end;

            @media (max-width: 767px) {
                padding-left: 0;
            }
            @media (min-width: 768px) {
                padding-left: 1.25rem;
            }
        `,
    },
    cancelButton: {
        variant: "secondary",
    },
};

const styles = defaultCarrierAndServiceStyles;
interface Carrier {
    id: string;
    description: string;
    shipVias: ShipVia[];
}
interface ShipVia {
    id: string;
    description: string;
    isDefault: boolean;
}
interface AccountPreferencesResponse {
    accountPreference: null | {
        id: string,
        userProfileId: string,
        preferenceKey: string,
        value: string,
        customerId: string,
    };
    carriers: Carrier[];
}
const DefaultCarrierAndService: FC<Props> = ({ apState, toaster }: Props) => {
    const [carriers, setCarriers] = useState<Carrier[]>([]);
    const [selectedCarrierId, setSelectedCarrierId] = useState<string>("");
    const [selectedShipViaId, setSelectedShipViaId] = useState<string>("");
    const [accountPreferenceId, setAccountPreferenceId] = useState<string>('');
    const [userProfileId, setUserProfileId] = useState<string>("");
    const [enableSaveButton, setEnableSaveButton] = useState<boolean>(false);
    const parameter: AccountPreferenceApiParameter = {
        id: accountPreferenceId
        , UserProfileId: userProfileId
        , PreferenceKey: 'CarrierAndService'
        , Value: JSON.stringify({ "carrierId": selectedCarrierId, "shipViaId": selectedShipViaId })
        , CustomerId: ''
    };

    useEffect(() => {
        const id = Object.getOwnPropertyNames(apState.data.billTos.byId)[0];
        setUserProfileId(id);
    }, [apState.data.billTos.byId]);

    useEffect(() => {
        if (!userProfileId) return;
        ap.getAccountPreferences(parameter).then((apiResponse: { response: AccountPreferencesResponse }) => {
            const { carriers, accountPreference } = apiResponse.response;
            setCarriers(carriers || []);

            if (accountPreference) {
                var carrierAndService = JSON.parse(accountPreference.value);
                setAccountPreferenceId(accountPreference.id);
                setUserProfileId(accountPreference.userProfileId);
                setSelectedCarrierId(carrierAndService.carrierId);
                setSelectedShipViaId(carrierAndService.shipViaId);
            }
            else if (carriers && carriers.length > 0) {
                // setSelectedCarrierId(carriers[0].id);
                // setSelectedShipViaId(carriers[0].shipVias[0]?.id || "");
                setAccountPreferenceId(newGuid());
            }
        });
    }, [userProfileId]);

    const handleCarrierChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const carrierId = event.target.value;
        setSelectedCarrierId(carrierId);
    };

    const [apiSuccess, setApiSuccess] = useState(false);
    const [isSetToClear, setisSetToClear] = useState(false);
    const handleShipViaChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedShipViaId(event.target.value);
        setEnableSaveButton(true);
    };


    useEffect(() => {
        if (apiSuccess) {
            toaster.addToast({
                body: (
                    <>
                        <Typography>{translate("You have successfully updated your Preferences.")}</Typography>
                    </>
                ),
                messageType: "info",
                timeoutLength: 10000,                
            });
            setApiSuccess(false);
        }
    }, [apiSuccess]);

    const handleSaveClick = () => {
        ap.createAccountPreferences(parameter).then((apiResponse: { response: AccountPreferencesResponse }) => {
            setApiSuccess(true);
            setEnableSaveButton(false);
        });
    };

    const setInitialValues = () => {
        setSelectedCarrierId("");
        setSelectedShipViaId("");
        setisSetToClear(true);
    };

    useEffect(() => {
        if (selectedCarrierId === "" && selectedShipViaId === "" && isSetToClear) {
            handleSaveClick();
            setEnableSaveButton(false);
        }
    }, [isSetToClear]);

    const selectedCarrier = carriers.find(c => c.id === selectedCarrierId);
    const featureFlags: string[] = ["TEGE-196"];
    const flagValues = useLaunchDarklyFlags({ featureFlags });
    const enablePreferredShippingCarrierAndService = flagValues["TEGE-196"];
    if (!enablePreferredShippingCarrierAndService) {
        return null;
    }
    return (
        <>
            <Typography {...styles.defaultPreferencesTitle}>{translate("Preferred Carrier And Service")}</Typography>
            <GridItem {...styles.carrierGridItem} id="carrierGridItem">
                <Select
                    label={translate("Select Carrier")}
                    {...styles.carrierSelect}
                    value={selectedCarrierId}
                    onChange={handleCarrierChange}
                    data-test-selector="checkoutReviewAndSubmit_carrierSelect"
                    name="carrier"
                >
                    <option value="">Select Carrier</option>
                    {carriers.map(carrier => (
                        <option key={carrier.id} value={carrier.id}>
                            {carrier.description}
                        </option>
                    ))}
                </Select>
            </GridItem>
            <GridItem {...styles.serviceGridItem} id="serviceGridItem">
                <Select
                    label={translate("Select Service")}
                    {...styles.serviceSelect}
                    value={selectedShipViaId}
                    onChange={handleShipViaChange}
                    data-test-selector="checkoutReviewAndSubmit_shippingServiceSelect"
                >
                    <option value="">Select Service</option>
                    {selectedCarrier?.shipVias.map(shipVia => (
                        <option key={shipVia.id} value={shipVia.id}>
                            {shipVia.description}
                        </option>
                    ))}
                </Select>
            </GridItem>
            <GridItem {...styles.buttonGridItem} id="buttonGridItem">
                <Button {...styles.cancelButton} onClick={setInitialValues}>
                    {translate("Clear")}
                </Button>
                <Button
                    {...styles.saveButton}
                    onClick={handleSaveClick}
                    disabled={!enableSaveButton}
                    data-test-selector="accountPreference_save"
                >
                    {translate("Save")}
                </Button>
            </GridItem>
        </>
    );
};


const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withProduct(withToaster(DefaultCarrierAndService))),
    definition: {
        displayName: "Default Carrier And Service",
        group: "Account Settings",
    },
};

export default widgetModule;

